import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminLayout = () => {
  const { email, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <div className="w-8 h-8 rounded bg-primary text-white flex items-center justify-center font-bold">M</div>
          <span>MillionMinds Admin</span>
        </div>
        
        <nav className="admin-nav">
          <div className="admin-nav-label">Dashboard</div>
          <NavLink to="/admin" end className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            📊 Overview
          </NavLink>
          
          <div className="admin-nav-label mt-4">Users</div>
          <NavLink to="/admin/students" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            🎓 Students
          </NavLink>
          <NavLink to="/admin/companies" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            🏢 Companies
          </NavLink>
          
          <div className="admin-nav-label mt-4">Content</div>
          <NavLink to="/admin/jobs" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            💼 Jobs & Postings
          </NavLink>
          <NavLink to="/admin/opportunities" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            🌟 Admin Opportunities
          </NavLink>
          <NavLink to="/admin/applications" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            📄 Applications
          </NavLink>
          
          <div className="admin-nav-label mt-4">System</div>
          <NavLink to="/admin/logs" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            📜 Audit Logs
          </NavLink>
          
          <div className="mt-auto pt-4 pb-2">
            <button onClick={handleLogout} className="admin-nav-item danger w-full">
              🚪 Logout
            </button>
          </div>
        </nav>
      </aside>
      
      <main className="admin-content">
        <header className="admin-topbar">
          <div className="font-medium text-gray-500">Admin Portal</div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">{email}</span>
            <div className="w-8 h-8 rounded-full bg-primary-light text-primary flex items-center justify-center font-bold text-sm border border-primary/20">
              A
            </div>
          </div>
        </header>
        
        <div className="admin-body">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
